<template>
  <div id="EchartS1">
    <div id="sanqidiv" style="height:100%;"></div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
import request from '@/utils/request'

export default {
  name: 'EchartS1',
  data() {
    return {
      // 需要合并对象，样式
      options: {},
      queryParams: {},
      data: [
        {
          value: ['1997-10-1 00:10:10', 684]
        },
        {
          value: ['1997-10-1 00:41:10', 200]
        },
        {
          value: ['1997-10-1 00:44:10', 300]
        },
        {
          value: ['1997-10-1 00:44:10', '-']
        },
        {
          value: ['1997-10-1 00:46:10', '-']
        },
        {
          value: ['1997-10-1 01:48:10', '-']
        }
      ]
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    const { refreshData } = this;

    // this.timer = setInterval(this.refreshData, 1000 * 60);
    refreshData()
  },
  methods: {
    refreshData(value) {
      const { refreshChart } = this;
      if (value === undefined) {
        value = this.queryParams
      } else {
        this.queryParams = value
      }
      request({
        url: 'Kanban/GetOnlinPlanAndKw',
        method: 'post',
        data: this.queryParams
      }).then(response => {
        const res = response
        // console.log(res)
        // var buPower = res.data.Data.PowerResult.PowerByBU
         var buName = []
         var buValue = []
        var countbuPower=0
        //  for (var i = 0; i < buPower.length; i++) {
        //   countbuPower+=parseInt(buPower[i][1])
        // }
        countbuPower  =res.data.sumKw
        var buPower =res.data.PlanPower
        
        const serColors = ['#2d99e2', '#61a0a8', '#99d0b9', '#8E8E38', '#008B45', '#6aa36a']
        buName.push({ name: '总功率:'+' '+countbuPower+'(MW)' })
        for (var i = 0; i < buPower.length; i++) {
          var intbuPower =buPower[i]
          buName.push({ name: intbuPower.PowerValue+ intbuPower.PlantCode })
          buValue.push({ source: '总功率:'+' '+countbuPower+'(MW)', target: intbuPower.PowerValue+ intbuPower.PlantCode, value:intbuPower.PowerValue })
        }
        buName.forEach((item, index) => {
          item.itemStyle = {
            normal: {
              color: serColors[index]
            }
          }
        })
        var chartData = { buName: buName, buValue: buValue }
        console.log(chartData)
        refreshChart(chartData)
      })
    },
    refreshChart(chartData) {
      var myChart = echarts.init(document.getElementById('sanqidiv'));

      var option = {
        title: {
          text: '',
          textStyle: { color: '#fff' },

          x: 'center'
        },
        grid: {
          x: 85,
          y: 45,
          x2: 85,
          y2: 20,
          borderWidth: 1,
        },
        series: {
          type: 'sankey',
          layout: 'none',
          label: {
            normal: { 
              color: '#fff',
              fontSize: 16
            }
          },
          data: chartData.buName,
          links: chartData.buValue
   
        
        }
      };

      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" >
#EchartS1 {
  position: absolute;
  top: 60%;
  width: 30%;
  height: 40%;
  background-color: #17293d;
  box-sizing: border-box;

}
</style>
